import { createContext } from 'react';

import {
  SoftwareVulnerabilityReportResponse,
  VulnerabilityReportFilterOptions,
  VulnerabilityReportInput,
} from '@totem/components/software/vulnerabilityReport/types';

interface Context {
  input: VulnerabilityReportInput;
  setInput: (input: VulnerabilityReportInput) => void;
  loading: boolean;
  data: SoftwareVulnerabilityReportResponse;
  filterOptions: VulnerabilityReportFilterOptions;
  action: string;
  onAction?: (action: string) => void;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  loading: false,
  data: null,
  filterOptions: null,
  action: '',
  onAction: () => {},
});
